import { WidgetInstance } from "friendly-challenge";
export default class Captcha{
    
    constructor(element) {
        this._wrapper = element;
        
        this.widget = new WidgetInstance(this._wrapper, {
            sitekey:"FCMTM158QGNMV5RS",
        });
        
    }
    
}